// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N9Mh","main":"styles_main__2sCtX"};